function showLogInWindow() {

}

$(function(){
    setInterval(function(){
        $.getJSON("/ping",function(response) {
            if(response.guest)
                window.location.reload(true);
            //ping complete.
        }).error(function(){
            window.location.reload(true);
        });
    },60*1000*10);//10 minutes
});